import { render, staticRenderFns } from "./PublicSecurity.vue?vue&type=template&id=a0979c4c&"
import script from "./PublicSecurity.vue?vue&type=script&lang=js&"
export * from "./PublicSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports